import { actionCreatorFactory } from "typescript-fsa";
import { scanmaster,  updatedata} from "../typing/table_typing";


const actionCreator = actionCreatorFactory("NETWORKSCANTABLE");

 const resetData = actionCreator<{data:updatedata[]}>("NETWORKSCANTABLE_RESETDATA");
 const setDeleteItem = actionCreator<{setDeleteItem:string}>("NETWORKSCANTABLE_DELETEDATA");
 const setRuleScanmasterItem = actionCreator<{setScanMasterItem:scanmaster[]}>("NETWORKSCANTABLE_RULESCANMSTERDATA");
 
 export const NetworkTableThingyActions = { resetData, setDeleteItem, setRuleScanmasterItem}


